module.exports = __webpack_public_path__ + "7bd9e444f9b5858e12af37df8ab628bb.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/nara-kasbergen.jpg
// module id = 673
// module chunks = 0